import React, { ReactElement } from 'react'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import { Box, useTheme } from '@mui/material'
import LoadingProgress from '@components/Elements/LoadingProgress'

export interface PlaylistEmptyStateProps {
  message: ReactElement
  isLoading?: boolean
}

const PlaylistEmptyState: React.FC<PlaylistEmptyStateProps> = ({
  message,
  isLoading,
}) => {
  const theme = useTheme()

  return (
    <Box
      height={'100%'}
      p={7}
      display="flex"
      justifyContent="center"
      alignItems="center"
      color="text.primary"
      flexDirection="column"
      textAlign="center"
    >
      {isLoading ? (
        <LoadingProgress />
      ) : (
        <>
          <Inventory2OutlinedIcon
            sx={{
              fontSize: 64,
              mb: 1,
              color: theme.palette.textOrIcon.tooltipButton,
            }}
          />
          {message}
        </>
      )}
    </Box>
  )
}

export default PlaylistEmptyState
